import { FaChevronDown } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
export const InputComponent = ({
  label,
  placeholder,
  type = "text",
  value,
  onChange,
  name,
  error,
  textColorStyle,
  ...props
}) => {
  return (
    <div className="input-wrap-comp">
      <label htmlFor={name}>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        className={error ? "input-error" : ""}
        // style={textColorStyle}
        {...props}
      />
      {error && (
        <div className="error-message">
          <MdErrorOutline className="error-icon" /> {error}
        </div>
      )}
    </div>
  );
};

export const InputCheckboxComponent = ({
  label,
  onChange,
  checked,
  ...props
}) => {
  return (
    // <div className="input-checkbox-comp">
    //   <input type="checkbox" onChange={onChange} {...props} />
    //   <label htmlFor="">{label}</label>
    // </div>

    <label className="checkbox-label">
      <input type="checkbox" checked={checked} onChange={onChange} {...props} />
      <span className="checkbox-custom"></span>
      {label}
    </label>
  );
};

export const InputSelectComponent = ({
  label,
  name,
  value,
  onChange,
  options,
  textColorStyle,
  defaultOption = "Select an option",
  ...props
}) => {
  return (
    <div className="select-wrap-comp">
      <label>{label}</label>
      <div className="custom-select-container">
        <select
          name={name}
          value={value}
          onChange={onChange}
          className="custom-select"
          // style={textColorStyle}
        >
          <option value="" disabled>
            {defaultOption}
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value}  >
              {option.label}
            </option>
          ))}
        </select>
        <FaChevronDown className="custom-select-icon" />
      </div>
    </div>
  );
};
